const LINK_DESTINATION_OPENER = "]("
const LINK_LABEL_OPENER = "["
const IMAGE_MARKER = "!"

export function withoutUnclosedTrailingLink(content: string): string {
  const destinationStart = content.lastIndexOf(LINK_DESTINATION_OPENER)
  if (destinationStart === -1) return content

  const destination = content.slice(destinationStart + LINK_DESTINATION_OPENER.length)
  if (destination.includes(")") || destination.includes("\n")) return content

  const labelStart = content.lastIndexOf(LINK_LABEL_OPENER, destinationStart)
  if (labelStart === -1) return content

  const label = content.slice(labelStart + LINK_LABEL_OPENER.length, destinationStart)
  const markerLength = content[labelStart - 1] === IMAGE_MARKER ? IMAGE_MARKER.length : 0
  return content.slice(0, labelStart - markerLength) + label
}
